import Step from './Step';
import { ModelType, DEFAULT_MODEL, DEFAULT_TEMPERATURE } from '../../config/models';

interface InferenceChainDefinition {
  model: ModelType;
  model_temp: number;
  prompt: string;
  variables?: Record<string, string>;
  retriever?: any | null;
  is_streaming: boolean;
  condition?: string;
}

class InferenceChainStep extends Step {
  constructor(description: string, definition: InferenceChainDefinition) {
    const defaultedDefinition = {
      ...definition,
      model: definition.model || DEFAULT_MODEL,
      model_temp: definition.model_temp ?? DEFAULT_TEMPERATURE,
      prompt: definition.prompt || '',
      variables: definition.variables || {},
      is_streaming: definition.is_streaming || false,
      condition: definition.condition
    };
    super("inference_chain", description, defaultedDefinition);
  }

  toJson() {
    // Ensure all required fields are present with defaults
    const definition = {
      model: this.definition.model || DEFAULT_MODEL,
      model_temp: this.definition.model_temp ?? DEFAULT_TEMPERATURE,
      prompt: this.definition.prompt || '',
      variables: this.definition.variables || {},
      is_streaming: this.definition.is_streaming || false,
      ...(this.definition.retriever ? { retriever: this.definition.retriever } : {}),
      ...(this.definition.condition ? { condition: this.definition.condition } : {})
    };

    return {
      type: 'inference_chain',
      params: {
        id: this.id,
        description: this.description,
        definition
      }
    };
  }

  static fromJson(json: any): InferenceChainStep {
    const definition = json.params?.definition || {};
    return new InferenceChainStep(
      json.params?.description || '',
      {
        model: definition.model || definition.llm || DEFAULT_MODEL,
        model_temp: definition.model_temp ?? DEFAULT_TEMPERATURE,
        prompt: definition.prompt || '',
        variables: definition.variables || {},
        is_streaming: definition.is_streaming || false,
        retriever: definition.retriever || null,
        condition: definition.condition
      }
    );
  }
}

export default InferenceChainStep;